"use client";

import { useState } from "react";
import { ChevronDown } from "react-feather";

/**
 * Income limits for Affordable Housing eligibility. Illuminus updates these
 * annually — change the effective date alongside the amounts.
 */
const EFFECTIVE_DATE = "5/1/26";

const INCOME_LIMITS = [
  { household: "1 Person", limit: "$35,600" },
  { household: "2 Person", limit: "$40,700" },
  { household: "3 Person", limit: "$45,800" },
  { household: "4 Person", limit: "$50,850" },
];

/**
 * Inline disclosure that sits directly beneath the interest select when
 * Affordable Housing is chosen. Native <details> so it stays keyboard and
 * screen-reader accessible without a modal or hover target.
 */
export default function IncomeEligibilityNote() {
  const [open, setOpen] = useState(false);

  return (
    <details
      open={open}
      className="rounded-3xl border border-border-color px-8 py-5 text-base sm:text-lg"
    >
      <summary
        onClick={(event) => {
          // Drive the disclosure from state so the chevron stays in sync.
          event.preventDefault();
          setOpen((wasOpen) => !wasOpen);
        }}
        className="flex cursor-pointer list-none items-center justify-between gap-4 font-semibold [&::-webkit-details-marker]:hidden"
      >
        <span>Income limits apply &mdash; see if you qualify</span>
        <span
          aria-hidden
          className="shrink-0 transition-transform duration-200"
          style={{ transform: open ? "rotate(180deg)" : "none" }}
        >
          <ChevronDown width={20} height={20} />
        </span>
      </summary>
      <div className="mt-4 text-base">
        <p>
          Eligibility is based on household size and total annual household
          income.
        </p>
        <table className="mt-4 w-full text-left">
          <caption className="sr-only">
            Affordable Housing income limits by household size
          </caption>
          <thead>
            <tr className="border-b border-border-color">
              <th scope="col" className="py-2 pr-4 font-semibold">
                Household Size
              </th>
              <th scope="col" className="py-2 font-semibold">
                Income Limit (as of {EFFECTIVE_DATE})
              </th>
            </tr>
          </thead>
          <tbody>
            {INCOME_LIMITS.map((row) => (
              <tr key={row.household} className="border-b border-border-color last:border-0">
                <th scope="row" className="py-2 pr-4 font-normal">
                  {row.household}
                </th>
                <td className="py-2">{row.limit}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="mt-4 text-sm">
          Limits are subject to change. If you are above these limits, our team
          can point you toward other Illuminus options.
        </p>
      </div>
    </details>
  );
}
